import TabsElementMetaData from './TabsElementMetaData';
import TabElementChildPresets from './TabsElementChildPresets';

const TabElementChildPreset = TabElementChildPresets[0];
const tabNames = ['Payment', 'Shipping', 'Returns'];
const children = [TabElementChildPreset, TabElementChildPreset, TabElementChildPreset];

const presets = [
  {
    type: TabsElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 600,
      height: 200,
    },
    compProps: {
      zIndex: 1,
      paddingTop: 8,
      paddingLeft: 8,
      paddingRight: 8,
      paddingBottom: 8
    },
    data: {
      tabNames: tabNames,
      children: children,
      compProps: {
        fontSize: 16,
        fontFamily: 'Open Sans',
      }
    },
    hidden: false
  }
];

export default presets;
